import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import React, { useEffect, useState } from "react";
import storage from "../../Services/Storage";
import Axios from "../../api/Axios";
import Loader from "../../Components/Loader";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";

const url = "CouponDisbursement/";
const GetCoupon_url = `${url}GetAllCoupons?`;
const GetDisburde_url = `${url}disbursecoupons?`;
const CheckCustInfo_url = `${url}CheckCustomerInfo`;

const CouponDisbursement = () => {
    const mopTypes = [
        { label: "Credit Note", value: "Credit Note" },
        { label: "", value: "" },
    ];

    const auth = storage.getLocal("user");
    const [couponList, setCouponList] = useState([]);
    const [selectedCouponList, setSelectedCouponList] = useState([]);
    const [selectedMopdata, setSelectedMopdata] = useState("Credit Note");
    const [successMessage, setSuccessMessage] = useState("");
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getCoupon();
    }, []);

    const getCoupon = async () => {
        setIsLoading(true);
        try {
            const Coupon_Url = `${GetCoupon_url}CompId=${auth.CompId}`;
            const response = await Axios.get(Coupon_Url);
            setCouponList(response.data.Data);
        } catch (error) {
            toast.error(error?.response?.data?.Message || "Something went wrong", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const checkBeforeSave = async () => {
        try{
            const requestBody = {
                customers: selectedCouponList.map((cust) => ({
                    customerId: cust.cust_id,
                    customerCode: cust.cust_code
                })),
            };
            const response = await Axios.post(CheckCustInfo_url, requestBody);
            if (response.data.Status === "Success"){
                saveCoupanData();
            }
            else{
                setSuccessMessage(response.data.Message);
                setShowSuccessDialog(true);
            }
        }catch(ex){
            console.log(ex);
        }
    };
    const saveCoupanData = async () => {
        if (!selectedCouponList || selectedCouponList.length === 0) {
            toast.warn("Please select at least one customer", {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }
        setIsLoading(true);
        try {
            const requestBody = {
                branchId: "000",
                userId: auth.UserId,
                empId: selectedCouponList[0].PARTY_ID,
                compId: auth.CompId,
                modeOfPayment: selectedMopdata,
                customers: selectedCouponList.map((cust) => ({
                    customerId: cust.cust_id,
                    customerName: cust.cust_name,
                    totalValue: cust.Totval,
                })),
            };
            const response = await Axios.post(GetDisburde_url, requestBody);
            if (response.data.Status === "Success") {
                const message =
          response.data.Message || "Report generated successfully!";
                setSuccessMessage(message);
                setShowSuccessDialog(true);
            }

            setSelectedCouponList([]);
            getCoupon();
        } catch (error) {
            toast.error(error?.response?.data?.Message || "Something went wrong", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <div className="col-12 pt-0 pb-4">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <h3 className="py-2">Coupon Disbursement</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12"></div>
                    </div>

                    <section className="sales-box">
                        <div className="row d-flex justify-content-end align-items-end">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <label className="form-label">
                  Mode Of Payment <span className="mandatory">*</span>
                                </label>
                                <Dropdown
                                    value={selectedMopdata}
                                    options={mopTypes}
                                    onChange={(e) => setSelectedMopdata(e.value)}
                                    optionLabel="label"
                                    placeholder="Select a Mode Of Payment"
                                />
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="text-end">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={checkBeforeSave}
                                    >
                    Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section>
                        <div className="DataTable">
                            <h3 className="py-2">Records</h3>
                            <DataTable
                                value={couponList}
                                rows={10}
                                filterDisplay="row"
                                stripedRows
                                scrollHeight="80vh"
                                scrollable
                                paginator
                                selection={selectedCouponList}
                                onSelectionChange={(e) => setSelectedCouponList(e.value)}
                                selectionMode="checkbox"
                            >
                                <Column
                                    selectionMode="multiple"
                                    header="Select All"
                                    headerStyle={{ width: "8rem" }}
                                />
                                <Column field="cust_code" header="Customer Code" />
                                <Column field="cust_name" header="Customer Name" />
                                <Column field="Totval" header="Total Coupon Value" />
                            </DataTable>
                        </div>
                    </section>
                </div>
            )}
            <Dialog
                header="Information"
                visible={showSuccessDialog}
                modal
                onHide={() => setShowSuccessDialog(false)}
                style={{ width: "30vw" }}
                closable={false}
                resizable={false}
                draggable={false}
                footer={
                    <div className="text-end">
                        <button
                            className="btn btn-primary"
                            onClick={() => setShowSuccessDialog(false)}
                        >
              OK
                        </button>
                    </div>
                }
            >
                <p className="m-0 text-center">{successMessage}</p>
            </Dialog>
        </>
    );
};

export default CouponDisbursement;
